import { useEffect, useMemo, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { customStyleSelect } from "utils/common";
import { statusOptions } from "utils/constants";

import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "components/Button";
import DateInput from "components/Form/dateInput";
import EssFullWidthModal from "components/modelpopup/baseModal";
import { format } from "date-fns";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import * as Yup from "yup";

const AddJobModal = ({
  createJobHandler,
  jobModal,
  setJobModal,
  loading,
  selectedJob,
  setSelectedJob
}) => {
  const modalRef = useRef();

  const [departmentOption, setDepartmentOption] = useState([]);

  const { department, departmentLoading } = useSelector(
    (state) => state.common
  );

  const { user, userLoading } = useSelector((state) => state.user);

  // Check if user has job_drive permission
  const hasJobDrivePermission = useMemo(() => {
    if (!user?.role?.permissions) return false;
    return user.role.permissions.some((p) => p.code === "job_drive") ||
           user?.modules?.some?.((m) => m.code === "job_drive");
  }, [user]);

  // Debug: Log permission check
  useEffect(() => {
    if (user?.role?.permissions) {
      const permissionCodes = user.role.permissions.map(p => p.code);
      console.log("AddJobModal - User permissions:", permissionCodes);
      console.log("AddJobModal - Looking for 'job_drive':", permissionCodes.includes("job_drive"));
      console.log("AddJobModal - Has job_drive permission:", hasJobDrivePermission);
    }
  }, [user, hasJobDrivePermission]);

  const jobRequestSchema = Yup.object().shape({
    title: Yup.string().required("Job name is required"),
    description: Yup.string(),
    department: Yup.object().required("Department is required"),
    expiry_date: Yup.string(),
    application_count: Yup.number(),
    status: Yup.object().required("Status is required"),
    job_drive_enabled: Yup.boolean(),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    reset,
  } = useForm({
    resolver: yupResolver(jobRequestSchema),
    defaultValues: {
      title: "",
      description: "",
      department: {},
      expiry_date: "",
      application_count: null,
      status: {},
      job_drive_enabled: false,
    },
  });

  useEffect(() => {
    if (department) {
      let _departments = department.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setDepartmentOption(_departments);
    }
  }, [department]);

  useEffect(() => {
    if (selectedJob?.title) {
      setValue("title", selectedJob?.title);
      setValue("description", selectedJob?.description);
      if (selectedJob?.department?.id) {
        console.log(
          selectedJob?.department?.id,
          departmentOption,
          "JJJJJJJJJJJJJJJJ"
        );
        setValue(
          "department",
          departmentOption.find(
            (item) => item.value === selectedJob?.department?.id
          )
        );
      }
      if (selectedJob?.status) {
        setValue(
          "status",
          statusOptions.find(
            (item) => item.value === selectedJob?.status.toLowerCase()
          )
        );
      }

      setValue("expiry_date", selectedJob?.expiry_date || "");

      setValue("application_count", selectedJob?.application_count);
      setValue("job_drive_enabled", selectedJob?.job_drive_enabled || false);
    }
  }, [selectedJob, jobModal, departmentOption, setValue]);

  const onSubmit = (data) => {
    console.log(data, "LLLLL");
    data["department"] = data?.department?.value;
    data["status"] = data?.status?.value;
    data["job_drive_enabled"] = data?.job_drive_enabled || false;
    if (data.expiry_date) {
      data["expiry_date"] = format(new Date(data.expiry_date), "yyyy-MM-dd");
    }
    createJobHandler(data, setError, modalRef, reset);
    // setError('status', { type: 'custom', message: 'custom message' });

    // setError("status", "status errrr")
  };

  const handleClose = () => {
    
    reset();
    setJobModal(false);
    setSelectedJob("")



  };

  return (
    <>
      <div role="dialog">
       
           <EssFullWidthModal
        mask={false}
              title={selectedJob?.id ? "Update Job" : "Add Job"}
              // style={{ top: 100 }}
              open={jobModal}
              width={"40%"}
              footer={[]}     
              onCancel={handleClose}
                className="full-width-modal"


            >
          <div className="modal-content">
            <div className="modal-header">
              {/* <h5 className="modal-title">Add Job</h5> */}
              {/* <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button> */}
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Job Title</label>

                      <Controller
                        name="title"
                        control={control}
                        // rules={{ required: 'File name is required' }}
                        render={({ field }) => (
                          <input
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="text"
                            placeholder="Job title"
                          />
                        )}
                      />
                      {errors.title && (
                        <small className="text-danger">
                          {errors.title?.message}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Department</label>
                      <Controller
                        name={`department`}
                        // name={"assignee"}
                        control={control}
                        // defaultValue=""
                        // rules={{ required: 'Select a contact' }}
                        render={({ field }) => (
                          <>
                            <Select
                              placeholder="Select department"
                              onChange={(e) => {
                                field.onChange(e);
                              }}
                              value={field.value}
                              options={departmentOption}
                              styles={customStyleSelect}
                              isLoading={departmentLoading}
                            />
                          </>
                        )}
                      />
                      {errors.department && (
                        <small className="text-danger">
                          {errors.department?.message}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  {/* <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Job Location</label>
                      <input disabled className="form-control" type="text" />
                    </div>
                  </div> */}
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">No of Vacancies</label>
                      <Controller
                        name="application_count"
                        control={control}
                        // rules={{ required: 'File name is required' }}
                        render={({ field }) => (
                          <input
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="number"
                            placeholder="No of vacancies"
                          />
                        )}
                      />
                      {errors.application_count && (
                        <small className="text-danger">
                          {errors.application_count?.message}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Status</label>
                      <Controller
                        name={`status`}
                        // name={"assignee"}
                        control={control}
                        // defaultValue=""
                        // rules={{ required: 'Select a contact' }}
                        render={({ field }) => (
                          <>
                            <Select
                              placeholder="Select status"
                              onChange={(e) => {
                                field.onChange(e);
                              }}
                              value={field.value}
                              options={statusOptions}
                              styles={customStyleSelect}
                            />
                          </>
                        )}
                      />
                      {console.log(errors, "EEEEEEEE")}
                      {errors.status && (
                        <small className="text-danger">
                          {errors.status?.message}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Experience</label>
                      <input disabled className="form-control" type="text" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Age</label>
                      <input disabled className="form-control" type="text" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Salary From</label>
                      <input disabled type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Salary To</label>
                      <input disabled type="text" className="form-control" />
                    </div>
                  </div>
                </div> */}
                <div className="row">
                  {/* <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label disabled className="col-form-label">Job Type</label>
                      <Select
                        placeholder="Select"
                        onChange={setSelectedOptionTwo}
                        options={optionsTwo}
                        styles={customStyleSelect}
                        isDisabled
                      />
                    </div>
                  </div> */}
                </div>
                <div className="row">
                  {/* <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Start Date</label>
                      <DatePicker
                      disabled
                        className="form-control floating datetimepicker"
                        selected={selectedDate}
                        onChange={handleDateChange}
                        dateFormat="dd-MM-yyyy"
                      />
                    </div>
                  </div> */}
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Expired Date</label>
                      <Controller
                        name="expiry_date"
                        control={control}
                        // rules={{ required: 'File name is required' }}
                        render={({ field }) => (
                          <DateInput
                            className="form-control floating datetimepicker "
                            selected={field?.value}
                            onChange={field.onChange}
                            dateFormat="dd-MM-yyyy"
                          />
                        )}
                      />
                      {errors.expiry_date && (
                        <small className="text-danger">
                          {errors.expiry_date?.message}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Description</label>
                      <Controller
                        name="description"
                        control={control}
                        // rules={{ required: 'File name is required' }}
                        render={({ field }) => (
                          <textarea
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="text"
                            rows={6}
                            placeholder="Job description"
                          />
                        )}
                      />
                      {errors.description && (
                        <small className="text-danger">
                          {errors.description?.message}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
                {hasJobDrivePermission && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="input-block mb-3">
                        <div className="form-check form-switch">
                          <Controller
                            name="job_drive_enabled"
                            control={control}
                            render={({ field }) => (
                              <>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="job_drive_enabled"
                                  checked={field.value || false}
                                  onChange={(e) => field.onChange(e.target.checked)}
                                  style={{ cursor: "pointer" }}
                                />
                                <label className="form-check-label" htmlFor="job_drive_enabled" style={{ cursor: "pointer", fontWeight: "500" }}>
                                  Enable Job Drive Mode
                                </label>
                                <small className="form-text text-muted d-block mt-1">
                                  When enabled, this job will use Job Drive workflow with QR code invitations and time-slot scheduling. Default email automation will be disabled.
                                </small>
                              </>
                            )}
                          />
                        </div>
                        {errors.job_drive_enabled && (
                          <small className="text-danger">
                            {errors.job_drive_enabled?.message}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <div className="submit-section">
                  <Button
                    loading={loading}
                    disabled={loading}
                    className="btn btn-primary submit-btn"
                    // data-bs-dismiss="modal"
                    // aria-label="Close"
                    // type="reset"
                    // onClick={() => handleSubmit(onSubmit)()}
                    type="submit"
                    label="Submit"
                  />
                </div>
              </form>
            </div>
          </div>
          </EssFullWidthModal>
          
      </div>
    </>
  );
};

export default AddJobModal;
